
import * as PGFuZHJvaWR4LmNvbGxlY3Rpb246Y29sbGVjdGlvbj4 from './androidx-collection-collection-wasm-js.mjs';
import * as PGtvdGxpbj4 from './kotlin-kotlin-stdlib.mjs';
import * as PG9yZy5qZXRicmFpbnMua290bGlueDphdG9taWNmdT4 from './kotlinx-atomicfu-atomicfu.mjs';
import * as PG9yZy5qZXRicmFpbnMua290bGlueDprb3RsaW54LWJyb3dzZXI_ from './kotlinx-browser.mjs';
import * as PG9yZy5qZXRicmFpbnMua290bGlueDprb3RsaW54LWNvcm91dGluZXMtY29yZT4 from './kotlinx-coroutines-coreWasm.mjs';
import { __ALL_EXPORTS as PGFuZHJvaWR4LmNvbGxlY3Rpb246Y29sbGVjdGlvbj4__ALL_EXPORTS } from './androidx-collection-collection-wasm-js.mjs';
import { __ALL_EXPORTS as PGtvdGxpbj4__ALL_EXPORTS } from './kotlin-kotlin-stdlib.mjs';
import { __ALL_EXPORTS as PG9yZy5qZXRicmFpbnMua290bGlueDphdG9taWNmdT4__ALL_EXPORTS } from './kotlinx-atomicfu-atomicfu.mjs';
import { __ALL_EXPORTS as PG9yZy5qZXRicmFpbnMua290bGlueDprb3RsaW54LWJyb3dzZXI___ALL_EXPORTS } from './kotlinx-browser.mjs';
import { __ALL_EXPORTS as PG9yZy5qZXRicmFpbnMua290bGlueDprb3RsaW54LWNvcm91dGluZXMtY29yZT4__ALL_EXPORTS } from './kotlinx-coroutines-coreWasm.mjs';
import { __TAG as wasmTag, getCachedJsObject } from './kotlin-kotlin-stdlib.mjs'

// Placed here to give access to it from externals (js_code)
let wasmExports;

if (typeof process !== 'undefined' && process.release.name === 'node') {
    function doNotUseRequire() {
        throw new Error("Do not use top-level require. Prefer to use JS import or define your own require instead. Read more: https://kotl.in/r9txlt")
    }

    var require = new Proxy((function() {}), {
        apply(target, thisArg, argumentsList) {
            if (globalThis.require != null) {
                return globalThis.require.apply(thisArg, argumentsList);
            } else {
                doNotUseRequire();
            }
        },
        get(target, prop, receiver) {
            if (globalThis.require != null) {
                return Reflect.get(globalThis.require, prop);
            } else {
                doNotUseRequire();
            }
        },
    });
}

export function setWasmExports(exports) {
    wasmExports = exports;
}

const js_code = {
    'androidx.compose.runtime.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.runtime.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.runtime.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.runtime.internal.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.runtime.internal.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.runtime.internal.WeakRef_$external_fun_1' : () => new WeakRef(),
    'androidx.compose.runtime.internal.WeakRef_$external_class_instanceof' : (x) => x instanceof WeakRef,
    'androidx.compose.runtime.internal.WeakRef_$external_class_get' : () => WeakRef
}

const StringConstantsProxy = new Proxy({}, {
  get(_, prop) { return prop; }
});

export const importObject = {
    js_code,
    intrinsics: {

        tag: wasmTag
    },
    "'": StringConstantsProxy,
    '<kotlin>': PGtvdGxpbj4__ALL_EXPORTS,
    '<org.jetbrains.kotlinx:kotlinx-coroutines-core>': PG9yZy5qZXRicmFpbnMua290bGlueDprb3RsaW54LWNvcm91dGluZXMtY29yZT4__ALL_EXPORTS,
    '<org.jetbrains.kotlinx:atomicfu>': PG9yZy5qZXRicmFpbnMua290bGlueDphdG9taWNmdT4__ALL_EXPORTS,
    '<androidx.collection:collection>': PGFuZHJvaWR4LmNvbGxlY3Rpb246Y29sbGVjdGlvbj4__ALL_EXPORTS,
    '<org.jetbrains.kotlinx:kotlinx-browser>': PG9yZy5qZXRicmFpbnMua290bGlueDprb3RsaW54LWJyb3dzZXI___ALL_EXPORTS,
};
    